import React, { useState, useRef } from "react";
import "../tooltip.css";

export default function Tooltip({
  text,
  children,
  position = "top",
  delay = 200,
}) {
  const [visible, setVisible] = useState(false);
  const timeoutRef = useRef(null);

  const showTooltip = () => {
    timeoutRef.current = setTimeout(() => {
      setVisible(true);
    }, delay);
  };

  const hideTooltip = () => {
    clearTimeout(timeoutRef.current);
    setVisible(false);
  };

  return (
    <div
      className="tooltip-container"
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
      onFocus={showTooltip}
      onBlur={hideTooltip}
    >
      {children}

      <div
        className={`tooltip-box ${position} ${
          visible ? "show" : ""
        }`}
      >
        {text}
      </div>
    </div>
  );
}